import {
  useDraftDeleteImageMutation,
  useDraftUploadImageMutation
} from "@/src-refactor/modules/store/qrtk/services/property-draft/property-draft.qrtk";
import { HGenerateFileData, IFileData } from "@rf-l1/file/helpers/create-file-data";
import { useFormContext } from "react-hook-form";
import { CPropertyFormKeys } from "../util/schemas/property-schema/propertySchema";
import { useParams } from "react-router-dom";
import { onSendEventBlockerEnd, onSendEventBlockerStart } from "./useUploadingBlocker";

const useManagerImagesDraft = () => {
  const { setValue, getValues } = useFormContext();
  const { idDraft } = useParams();
  const draftId = Number(idDraft);
  const [uploadImage] = useDraftUploadImageMutation();
  const [deleteImage] = useDraftDeleteImageMutation();

  const uploadImageDraft = async (data: IFileData) => {
    return new Promise(async (resolve, reject) => {
      try {
        onSendEventBlockerStart();
        if (data.file instanceof File == false) {
          onSendEventBlockerEnd();
          return reject(new Error("No file provided"));
        }
        const res = await uploadImage({
          params: {
            draft: draftId
          },
          body: {
            image: data.file as File,
            order: "1"
          }
        })
          .then(res => {
            const picture = HGenerateFileData({
              file: res.data?.data.path ?? "",
              id: Number(res.data?.data.id) ?? 0,
              comment: ""
            });

            const newArray = [...getValues(CPropertyFormKeys.images_property)];
            const pos = newArray.findIndex(item => item.id === data.id);
            newArray.splice(pos, 1, picture);

            setValue(CPropertyFormKeys.images_property, [...newArray]);
            resolve({
              url: picture?.url ?? "",
              id: picture?.id.toString() ?? ""
            });
          })
          .catch(err => {
            reject(err);
          })
          .finally(() => {
            onSendEventBlockerEnd();
          });
      } catch (e) {
        onSendEventBlockerEnd();
        reject(e);
      }
    });
  };

  const deleteImageDraft = (index: number) => {
    return new Promise(async (resolve, reject) => {
      try {
        const fields = getValues(CPropertyFormKeys.images_property) as IFileData[];
        const resourceId = fields?.[index]?.id;

        if (resourceId) {
          await deleteImage({
            params: {
              draft: draftId,
              image: resourceId
            }
          }).unwrap();
        }

        setValue(
          CPropertyFormKeys.images_property,
          fields.filter((_, i) => i !== index)
        );
        resolve(void 0);
      } catch (err) {
        reject(err);
      }
    });
  };

  const deleteAllImagesDraft = async (current?: IFileData[]) => {
    const fields =
      (current ?? (getValues(CPropertyFormKeys.images_property) as IFileData[])) ||
      [];
    const remaining: IFileData[] = [];
    const failedDeletions: Array<{ id: number; error: any }> = [];

    for (let i = 0; i < fields.length; i++) {
      const file = fields[i];
      const resourceId = file?.id;

      // Si tiene id en backend, intentar eliminar; si falla, conservar local
      if (resourceId) {
        try {
          await deleteImage({
            params: { draft: draftId, image: resourceId }
          }).unwrap();
          // eliminado OK => no push a remaining
        } catch (error) {
          // Si falla la eliminación en el servidor, conservar el archivo localmente
          // y registrar el error para posible retry posterior
          console.warn(`Error eliminando imagen ${resourceId} del servidor:`, error);
          failedDeletions.push({ id: Number(resourceId), error });
          remaining.push(file);
        }
      }
      // Los archivos locales sin id se eliminan automáticamente (no se añaden a remaining)
    }

    setValue(CPropertyFormKeys.images_property, remaining);

    // Si hay fallos, retornar información para manejo adicional
    if (failedDeletions.length > 0) {
      console.warn(
        `${failedDeletions.length} imágenes no pudieron eliminarse del servidor`
      );
    }

    return { remaining, failedDeletions };
  };

  return {
    uploadImageDraft,
    deleteImageDraft,
    deleteAllImagesDraft
  };
};

export default useManagerImagesDraft;
